import { Box, OutlinedTextFieldProps, TextField } from '@mui/material';
import React, { forwardRef, CSSProperties } from 'react';
import { Text } from './Text';
import { colorSet, typography } from '@theme';

interface ITextInputProps extends Partial<Omit<OutlinedTextFieldProps, 'variant' | 'size'>> {
  label?: string;
  helperText?: string;
  isError?: boolean;
  boxstyle?: CSSProperties;
  style?: CSSProperties;
  mainColor?: string;
}

//forwardRef를 적용하여 ref를 받을 수 있도록 함
export const TextInput = forwardRef<HTMLInputElement, ITextInputProps>(
  ({ label, helperText, isError, boxstyle, style, mainColor = colorSet.primaryMain, ...rest }, ref) => {
    return (
      <Box style={boxstyle}>
        {label ? (
          <Text variant="subtitle" fontWeight="bold" marginBottom="8px">
            {label}
          </Text>
        ) : null}

        <TextField
          {...rest}
          inputRef={ref} //ref를 input에 전달
          variant="outlined"
          error={isError}
          sx={{
            width: '100%',
            '.MuiOutlinedInput-root': {
              ':hover': {
                border: `1px solid ${mainColor}`
              },
              '&.Mui-focused': {
                border: `1px solid ${colorSet.gray600}`
              },
              '&.Mui-error': {
                border: `1px solid ${colorSet.errorMain}`
              },
              '&.Mui-disabled': {
                border: `1px solid ${colorSet.gray300}`,
                backgroundColor: colorSet.gray200,
                color: colorSet.gray400
              }
            },
            '.MuiOutlinedInput-input': {
              '&::placeholder': {
                color: colorSet.gray300,
                opacity: 1,
                ...typography.body1
              }
            }
          }}
          style={{ ...style }}
        />
        {helperText && helperText.length > 0 ? (
          <Text variant="body2" color={isError ? colorSet.errorMain : colorSet.gray400} marginTop="4px">
            {helperText}
          </Text>
        ) : null}
      </Box>
    );
  }
);

//displayName 추가 (ESLint 경고 방지)
TextInput.displayName = 'TextInput';
